import React, { memo } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';

import { IProps } from './model';
import { Card } from '@core/design-system/card';

export const FundStats = memo<IProps>(
  ({ title, value, negativeValue, loading, icon }: IProps) => {
    return (
      <Grid
        item
        xs={6}
        sm={6}
        lg={2}
        role="rowgroup"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Card cardProps={{ sx: { width: '100%', p: 2 } }}>
          <Box
            display={'flex'}
            justifyContent={'center'}
            alignItems={'center'}
            mb={2}
            sx={{
              backgroundColor: '#90939e',
              color: '#fff',
              width: '24px',
              height: '24px',
              borderRadius: '4px',
            }}
          >
            {icon}
          </Box>
          <Typography
            component="h3"
            variant="body1"
            role="columnheader"
            fontWeight={500}
          >
            {title}
          </Typography>
          <Typography
            component="p"
            variant="h4"
            role="cell"
            fontWeight={700}
            color={negativeValue && 'error'}
          >
            {loading ? <Skeleton width={120} /> : value}
          </Typography>
        </Card>
      </Grid>
    );
  }
);
